import React from 'react'
import Header from '../../Components/Header'
import stampingTool from "../../imagens/stampingTools/stampingTool1.JPG"
import stampingTool2 from "../../imagens/stampingTools/stampingTool2.JPG"
import stampingTool3 from "../../imagens/stampingTools/stampingTool3.JPG"
import stampingTool4 from "../../imagens/stampingTools/stampingTool4.JPG"
import stampingTool5 from "../../imagens/stampingTools/stampingTool5.JPG"
import stampingTool6 from "../../imagens/stampingTools/stampingTool6.JPG"
import stampingTool7 from "../../imagens/stampingTools/stampingTool7.JPG"
import stampingTool8 from "../../imagens/stampingTools/stampingTool8.JPG"
import stampingTool9 from "../../imagens/stampingTools/stampingTool9.JPG"
import stampingTool10 from "../../imagens/stampingTools/stampingTool10.JPG"

import StampingToolCapabilities from '../../Components/stampingToolCapabilities'

const listStampingTool = [
    {
        img: stampingTool
    },
    {
        img: stampingTool2
    },
    {
        img: stampingTool3
    },
    {
        img: stampingTool4
    },
    {
        img: stampingTool5
    },
    {
        img: stampingTool6
    },
    {
        img: stampingTool7
    },
    {
        img: stampingTool8
    },
    {
        img: stampingTool9
    },
    {
        img: stampingTool10
    },
]



function StampingToolPage() {
    return (
        <div>
            <Header />
            <StampingToolCapabilities
                listStampingTool={listStampingTool}
            />
        </div>
    )
}

export default StampingToolPage